import { round, sumBy } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { UpdateCapitalActionFormValues } from '../../../hooks/useCapitalActionForm';

export default function useSyncInitialRefundValues({
  overpaidActions,
  entryIndex,
}: {
  overpaidActions: Array<{
    commitmentId: string;
    totalOverpaymentAmountLcy: number;
    investorName: string;
    actions: Array<{
      id: string;
    }>;
  }>;
  entryIndex: number;
}) {
  const { setValue, watch } = useFormContext<UpdateCapitalActionFormValues>();

  const currentCapitalBreakdown = watch(
    `entries.${entryIndex}.capitalBreakdown`,
  );

  useEffect(() => {
    if (currentCapitalBreakdown?.length) {
      return;
    }

    const capitalBreakdown = overpaidActions.map((action) => ({
      commitmentId: action.commitmentId,
      amountLcy: action.totalOverpaymentAmountLcy,
    }));

    setValue(`entries.${entryIndex}.capitalBreakdown`, capitalBreakdown);

    setValue(
      `entries.${entryIndex}.totalAmountLcy`,
      round(sumBy(overpaidActions, 'totalOverpaymentAmountLcy'), 2),
    );
  }, [overpaidActions, entryIndex, currentCapitalBreakdown?.length]);
}
